<template>
    <div>
        <el-table :data="list" border style="width: 100%"  v-loading="loading">
            <el-table-column type="expand">
                <template slot-scope="props">
                    <component :is="currentView" :edit_content="props.row"></component>
                </template>
            </el-table-column>
            <el-table-column prop="user_name" label="操作人"></el-table-column>
            <el-table-column prop="created_at_memo" label="操作时间"></el-table-column>
            <el-table-column label="执行操作">
                <template>修改配置</template>
            </el-table-column>
        </el-table>
        <el-row v-if="linkPage">
            <pagination :linkPage="linkPage"></pagination>
        </el-row>
    </div>
</template>

<script>
    import Pagination from "~/widgets/Pagination.vue";
    import OrderService from "~/services/order";
    import xwt from "~/views/order/recoder/xwt.vue";
    import zujuan from "~/views/order/recoder/zj.vue";
    import zujuanCor from "~/views/order/recoder/zjCor.vue";
    import jbzyk from "~/views/order/recoder/jbzyk.vue";
    import jb3 from "~/views/order/recoder/jb3.vue";
    import digitizedcampus from "~/views/order/recoder/szxy.vue";
    import vr from "~/views/order/recoder/vr.vue";
    import teacherFiles from "~/views/order/recoder/teacherFiles.vue";
    import smartHomework from "~/views/order/recoder/smartHomework.vue";
    import flexScheduling from "~/views/order/recoder/flexScheduling.vue";
    import division from "~/views/order/recoder/division.vue";
    import paikeNew from "~/views/order/recoder/paikeNew.vue";
    // import Config from "~/config/params";
    import ProductService from "~/services/product";
    export default {
        components:{
            Pagination,
            xwt,
            zujuan,
            zujuanCor,
            jbzyk,
            jb3,
            digitizedcampus,
            vr,
            teacherFiles,
            smartHomework,
            flexScheduling,
            ProductService,
            division,
            paikeNew
        },
        name: "baseModel",
        props:{
            product_id:{
                required:true
            },
            customer_id:{
                required: true
            },
            product_list:{
                required: true
            }
        },
        computed: {
            currentView: function () {
                let product = this.product_list.find(i => {
                    return i.id == this.product_id
                });
                console.log('自定义组件：', product['component']);
                return product['component'];
            }
        },
        created(){
            this.getRecord();
        },
        data(){
            return {
                loading:false,
                list:[],
                linkPage: null,

            }
        },
        methods:{
            getRecord(){
                this.loading = true;
                OrderService.getRecord({product_id:this.product_id,customer_id:this.customer_id,is_used: 1}).then(res=>{
                    this.list = res.data;
                    this.linkPage = res._meta;
                    this.loading = false;
                });
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/recoder/base.vue